module.exports = __webpack_public_path__ + "img/unodc_logo.64cb186e.png";